<h2 mat-dialog-title data-test-id="reviewers-upload-dialog">{{ persona.name }}</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <h2>Summary:</h2>
  <p>{{ persona.summary }}</p>
  <div class="in-progress-message" *ngIf="uploadInProgress$ | async">
    <mat-spinner></mat-spinner>
    <p>Uploading document...</p>
  </div>
  <div class="success-message" *ngIf="uploadSuccess$ | async">
    <p>Upload successful! Please wait 5-10 minutes while your review is processed</p>
    <p>You can now close this dialog and check your review status in the review section</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close *ngIf="(uploadSuccess$ | async) === false" data-test-id="reviewers-upload-cancel-btn">Cancel</button>
  <button mat-stroked-button cdkFocusInitial (click)="inputFile()" *ngIf="(uploadSuccess$ | async) === false" data-test-id="reviewers-upload-document-btn">
    <mat-icon>upload_file</mat-icon>Upload a document To review
  </button>
  <button mat-stroked-button mat-dialog-close *ngIf="uploadSuccess$ | async">Close</button>
  <input
    type="file"
    #fileInputPersona
    style="display: none"
    accept="application/pdf,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    (input)="onDocumentUpload($event)"
    multiple />
</mat-dialog-actions>
